module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_devices.3e83e4f4.svg";